module.exports = __webpack_public_path__ + "static/media/icon_calendar_b.e27f9107.svg";